import { jsx, jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Box, Grow, Popover } from "@mui/material";
import { useColorPicker } from "../hooks/useColorPicker.js";
function ColorPickerPopover(props) {
  const { Component, onSetOpen, open, children, testId = "ColorPickerPopover", ...triggerExtraProps } = props;
  const anchorRef = useRef(null);
  const { color } = useColorPicker();
  const handleClose = () => {
    onSetOpen(false);
  };
  const handleOpen = () => {
    onSetOpen(true);
  };
  return /* @__PURE__ */ jsxs(Box, { ref: anchorRef, "data-testid": testId, children: [
    /* @__PURE__ */ jsx(Component, { onClick: handleOpen, color, open, ...triggerExtraProps }),
    /* @__PURE__ */ jsx(
      Popover,
      {
        TransitionComponent: Grow,
        anchorEl: anchorRef.current,
        anchorOrigin,
        transformOrigin,
        onClose: handleClose,
        open,
        children
      }
    )
  ] });
}
const anchorOrigin = { vertical: "bottom", horizontal: "left" };
const transformOrigin = { vertical: -8, horizontal: 0 };
export {
  ColorPickerPopover
};
//# sourceMappingURL=ColorPickerPopover.js.map
